/**
 * Bosh sahifadagi bo'limlarga langar havolalar.
 *
 * "Xizmatlar" bu yerda yo'q — u header'da alohida mega menyu sifatida
 * chiqadi va haqiqiy sahifalarga (/xizmatlar/...) olib boradi.
 */
const menus = [
    { id: 1, name: 'main', links: '#asosiy' },
    { id: 2, name: 'about-us', links: '#haqimizda' },
    { id: 3, name: 'partnering', links: '#hamkorlik' },
    { id: 4, name: 'questions', links: '#savollar' },
    { id: 5, name: 'connection', links: '#aloqa' },
]

export default menus;
